export default "__VITE_ASSET__BrM_MUCA__"